import { createConsumer } from "@rails/actioncable"

const consumer = createConsumer()

if (typeof window !== 'undefined') {
  window.App = window.App || {}
  window.App.cable = consumer
}

export default consumer
